// extras-availability.js — pure availability GATES for operator extras, shared by
// the customer funnel (src/components/App.jsx getVisibleExtras) and the server-side
// alternatives resolver (src/pages/api/_helpers.js getAlternativeAircraft) so that
// "which extras are offered" is ONE source of truth — display == bookability, no
// divergence. No pricing, no I/O. Logic is the exact prior App.jsx definitions.

// Seat-aware gate for kind='pilot' extras. A second pilot needs a free
// cockpit-pax-seat; hidden until the operator has verified the aircraft's seat
// config (safe fallback), and never on a 2-pilot-mandatory aircraft.
export function canBookPilotExtra(aircraft, paxCount) {
  if (!aircraft) return false;
  if (aircraft.needsSeatVerification) return false;
  if (aircraft.requiresTwoPilots) return false;
  const cockpitPax = Number(aircraft.cockpitPaxSeats) || 0;
  if (cockpitPax === 0) return false;
  const cabin = Number(aircraft.cabinSeats) || 0;
  const cockpitPaxUsed = Math.max(0, (Number(paxCount) || 0) - cabin);
  return (cockpitPax - cockpitPaxUsed) >= 1;
}

// Location-aware gate. Extras with locationIds[] only show when the itinerary
// touches one of those helipads; extras with no locationIds always show.
export function isExtraAvailableForItinerary(extra, itineraryHelipadIds) {
  if (!extra.locationIds || extra.locationIds.length === 0) return true;
  return extra.locationIds.some(id => itineraryHelipadIds.includes(id));
}
